var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#505050;stroke-linecap:round;stroke-linejoin:round;}")),React.createElement("g",{"id":"Ebene_2","data-name":"Ebene 2","key":1},React.createElement("g",{"id":"Nav_Overlayed"},[React.createElement("polyline",{"className":"cls-1","points":"0.5 0.5 3.26 3.26 0.5 6.03","key":0}),React.createElement("polyline",{"className":"cls-1","points":"6.03 6.03 3.26 3.26 6.03 0.5","key":1})]))]);
}

Close.defaultProps = {"viewBox":"0 0 6.53 6.53"};

module.exports = Close;

Close.default = Close;
